<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-agent" class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :disabled="disabled"
      id="form-pass-agent"
      class="show-tick form-control"
      @input="emit"
      @change="emit"
      @blur="emit"
    >
      <option v-for="agentOrganization in items" :key="agentOrganization.id" :value="agentOrganization.id">
        {{ agentOrganization.name }}
      </option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'AgentOrganizationInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Агент'
    },

    inputName: {
      default: 'agent_organization_id'
    },

    inputHint: {
      default: undefined
    },

    items: {
      type: [Array, Object],
      default: () => []
    }
  }
}
</script>
